import request from '@/router/axios'

const API = '/api/produce/kanban/fault-tracking'

function unwrap(res) {
  const body = res && res.data
  if (body && Object.prototype.hasOwnProperty.call(body, 'data')) return body.data
  return body || {}
}

export function fetchFaultTracking(params = {}) {
  return request({
    url: API,
    method: 'post',
    data: params
  }).then(unwrap)
}
